/**
 * Created by user on 2017/12/8/008.
 */
import {
	toFullEnglish,
	toFullNumber,
	toFullWidth,
	toHalfEnglish,
	toHalfNumber,
	toHalfWidth,
	type IFactoryFn,
} from '@lazy-cjk/fullhalf';

export {
	toFullNumber,
	toHalfNumber,

	toFullEnglish,
	toHalfEnglish,

	toFullWidth,
	toHalfWidth,
}

export default {
	toFullNumber,
	toHalfNumber,

	toFullEnglish,
	toHalfEnglish,

	toFullWidth,
	toHalfWidth,
}
